import { Plus, X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

// A repeatable list of free-text strings (used for `questions` and `tags`). Empty
// entries are kept while editing and trimmed by the caller on submit. Rows are
// positional, so the array index is the natural key.
export function StringListInput({
  values,
  onChange,
  placeholder,
  addLabel,
}: {
  values: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
  addLabel: string;
}) {
  const setAt = (index: number, value: string) => {
    onChange(values.map((entry, i) => (i === index ? value : entry)));
  };
  const removeAt = (index: number) => {
    onChange(values.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-2">
      {values.map((value, index) => (
        <div key={index} className="flex items-center gap-2">
          <Input
            value={value}
            placeholder={placeholder}
            onChange={(event) => setAt(index, event.target.value)}
          />
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label="Remove"
            onClick={() => removeAt(index)}
          >
            <X className="size-4" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => onChange([...values, ''])}>
        <Plus className="size-4" />
        {addLabel}
      </Button>
    </div>
  );
}
